module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6014HD_white-ac0201e16a27cd239363b7c93899676c.png";